import * as React from "react";
import defaultStyle from "./PannerBlockView.module.scss";
import { BlockBase, useBlocks } from "@jelly/lesson";
import classnames from "classnames";

type directions = "n" | "ne" | "e" | "se" | "s" | "sw" | "w" | "nw" | "off";
export interface PannerBlockOptions {
  audio: { [key in directions]: string };
  hideIcon?: boolean;
}
export interface PannerBlock extends BlockBase<PannerBlockOptions> {
  type: "panner3";
}

export const Panner3BlockView: React.FC<PannerBlockOptions> = (props) => {
  const [activeSample, setActiveSample] = React.useState<directions>("off");

  const hideIcon = props.hideIcon;
  const block = useBlocks();

  const handleSampleSwitch = (index: directions): void => {
    if (index !== "off") {
      setActiveSample(index);
    }
    if (index == activeSample) {
      setActiveSample("off");
    }
  };

  return (
    <div className={classnames(defaultStyle.root)}>
      {activeSample != "off" && (
        <block.audio src={props.audio[activeSample]} autoplay={true} key={activeSample} styles={{ display: "none" }} />
      )}
      <div className={classnames([hideIcon ? defaultStyle.circleNoIcon : defaultStyle.circle])}>
        <div className={classnames(defaultStyle.sectionsWrapper)}>
          <div
            className={classnames(defaultStyle.dot, defaultStyle.n, { [defaultStyle.active]: activeSample == "n" })}
            onClick={() => handleSampleSwitch("n")}
          />
          <div
            className={classnames(defaultStyle.dot, defaultStyle.ne, { [defaultStyle.active]: activeSample == "ne" })}
            onClick={() => handleSampleSwitch("ne")}
          />
          <div
            className={classnames(defaultStyle.dot, defaultStyle.e, { [defaultStyle.active]: activeSample == "e" })}
            onClick={() => handleSampleSwitch("e")}
          />
          <div
            className={classnames(defaultStyle.dot, defaultStyle.se, { [defaultStyle.active]: activeSample == "se" })}
            onClick={() => handleSampleSwitch("se")}
          />
          <div
            className={classnames(defaultStyle.dot, defaultStyle.s, { [defaultStyle.active]: activeSample == "s" })}
            onClick={() => handleSampleSwitch("s")}
          />
          <div
            className={classnames(defaultStyle.dot, defaultStyle.sw, { [defaultStyle.active]: activeSample == "sw" })}
            onClick={() => handleSampleSwitch("sw")}
          />
          <div
            className={classnames(defaultStyle.dot, defaultStyle.w, { [defaultStyle.active]: activeSample == "w" })}
            onClick={() => handleSampleSwitch("w")}
          />
          <div
            className={classnames(defaultStyle.dot, defaultStyle.nw, { [defaultStyle.active]: activeSample == "nw" })}
            onClick={() => handleSampleSwitch("nw")}
          />
        </div>
        <div className={defaultStyle.head} />
      </div>
    </div>
  );
};
